import service from '@/utils/server';

const modName='/taskPkg/list/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};

/**
 * 新增*提交
 * @param data
 * @returns {*}
 */
export const submitImport = data => {
  return service({
    url: modName + 'submit',
    method: 'post',
    data
  });
};

/**
 * 编辑初始化
 * @param data
 * @returns {*}
 */
export const taskPkgEditInit = data => {
  return service({
    url: modName + 'taskPkgEditInit',
    method: 'post',
    data
  });
};

/**
 * 删除
 * @param data
 * @returns {*}
 */
export const deleteData = data => {
  return service({
    url: modName + 'delete',
    method: 'post',
    data
  });
};
/**
 * 关闭
 * @param data
 * @returns {*}
 */
export const closeData = data => {
  return service({
    url: modName + 'close',
    method: 'post',
    data
  });
};

/**
 * 修改提交
 * @param data
 */
export const taskPkgEdit =data=>{
  return service({
    url: modName + 'taskPkgEdit',
    method: 'post',
    data
  });
}

/**
 * 详情
 * @param data
 */
export const taskPkgDetail = data =>{
  return service({
    url: modName + 'taskPkgDetail',
    method: 'post',
    data
  });
}

/**
 * 首页推送
 * @param data
 * @returns {*}
 */
export const homePush = data =>{
  return service({
    url: modName + 'homePush',
    method: 'post',
    data
  });
}

/**
 * 首页排行
 * @param data
 * @returns {*}
 */
export const homeRanking = data =>{
  return service({
    url: modName + 'homeRanking',
    method: 'post',
    data
  });
}

//导出excel
export const exportData = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'export',
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/taskManagement/taskList/api/index.js